import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { Button, Dialog, Link, Typography } from 'wtb-components';
import { useTransactionContext } from 'context';
import { isEmail } from 'utils';
import styles from './DialogExpired.module.css';

const DialogExpired = ({ openDialog, closeDialog }) => {
  const { t: translate } = useTranslation();

  const { campaign: { email } } = useTransactionContext();

  return (
    <Dialog
      isOpen={openDialog}
      hasCloseIcon={false}
      popupClassName={styles.dialog}
    >
      <div className={styles.line} />
      <div className={styles.title}>
        <Typography variant="h6" align="center">{translate('finish.dialogExpired.title')}</Typography>
      </div>

      <div className={styles.content}>
        <Typography variant="body1" align="center" component="p" className={styles.subtitle}>
          {translate('finish.dialogExpired.subtitle1')}
        </Typography>
        <Typography variant="body1" align="center" component="p" className={styles.subtitle}>
          <Trans
            i18nKey="finish.dialogExpired.subtitle2"
            values={{ email }}
            components={[
              <Link
                variant="body1"
                color="tertiary"
                underline="hover"
                href={isEmail(email) ? `mailto:${email}` : email}
              />
            ]}
          />
        </Typography>

        <div className={styles.buttons}>
          <div className={styles.linkWrapper}>
            <Link
              className={styles.buttonLink}
              href={isEmail(email) ? `mailto:${email}` : email}
              onClick={closeDialog}
              color="tertiary"
              underline="none"
            >
              {translate('finish.dialogExpired.action1')}
            </Link>
          </div>

          <Button
            variant="secondary"
            className={styles.button}
            onClick={closeDialog}
          >
            {translate('finish.dialogExpired.action2')}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default DialogExpired;
